function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
        this.input.stepUp();
    } else if (event.target.name === 'minus') {
        if (previousValue !== '1') {
            this.input.stepDown();
        } else {
            this.removeCartItem(event);
        }
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  } 

  removeCartItem(event) {
    const cartItems = event.target.closest('cart-items') || event.target.closest('cart-drawer-items');
    
    if (!cartItems) {
        console.error('Could not find parent cart-items or cart-drawer-items.');
        return;
    }
    
    const index = event.target.dataset.index;
    
    if (typeof index === 'undefined') {
        console.error('data-index attribute is missing.');
        return;
    }
    
    cartItems.updateQuantity(index, 0);
}

}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.mediaGallery = this.closest('media-gallery');
    this.counterBar = this.querySelector('.slider-counter-bar');
    this.counterBarCurrent = this.querySelector('.slider-counter-bar--current');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    if (this.sliderItemOffset < 1) {
      this.isVertical = true;
      this.sliderItemOffset = this.sliderItemsToShow[1].getBoundingClientRect().top - this.sliderItemsToShow[0].getBoundingClientRect().top
    }

    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset) || 1;
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    
    if (this.counterBar) {
      // clear current dashes
      this.counterBar.innerHTML = '';
      
      // create dashes
      for (let i = 0; i < this.totalPages; i++) {
          const dash = document.createElement('span');
          dash.classList.add('slider-counter-bar--dash');
          if (i === 0) dash.classList.add('active');  // make the first dash active initially
          this.counterBar.appendChild(dash);
      }
      
      // grab a reference to all dashes
      this.counterBarDashes = this.counterBar.querySelectorAll('.slider-counter-bar--dash');
  }
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round((this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft) / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.counterBarDashes) {
      this.counterBarDashes.forEach((dash, index) => {
          if (index === this.currentPage - 1) {
              dash.classList.add('active');
          } else {
              dash.classList.remove('active');
          }
      });
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const activeSlide = this.querySelector('.is-active');

    const newSlide =
      event.currentTarget.name === "next"
        ? activeSlide.nextSibling
        : activeSlide.previousSibling;
    
    if (newSlide) {
      this.mediaGallery.setActiveMedia(newSlide.dataset.mediaId, false);
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    this.idInput = this.productForm.querySelector(
      `input[name="items[${this.dataset.index}][id]"]`
    );
    this.quantityInput = document.querySelector(
      `input[name="items[${this.dataset.index}][quantity]"]`
    );
    this.preorderInput = document.querySelector(
      `input[name="items[${this.dataset.index}][properties[Pre-order]]"]`
    );
    this.productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    this.addEventListener("change", this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange(e) {
    if (e.target.type === "checkbox") {
      if (!e.target.checked) {
        this.disableOption();
        return;
      }

      const previouslyChecked = Array.from(
        this.querySelectorAll(`input[name="${e.target.name}"]`)
      ).find(
        (optionInput) => optionInput.id !== e.target.id && optionInput.checked
      );

      if (previouslyChecked) {
        previouslyChecked.checked = false;
      } else {
        this.enableOption();
      }
    }

    this.updateOptions();
    this.updateMasterId();

    if (this.currentVariant) {
      this.updateVariantInput();
      const variantGroup = this.closest("variant-select-group");
      variantGroup.updateForm();
      this.announceVariantChange();
      this.togglePreorder();
      this.updateURL();
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  disableOption() {
    this.querySelectorAll("input").forEach((input) => (input.checked = false));
    this.idInput.disabled = true;
    this.quantityInput.value = 0;
    this.quantityInput.disabled = true;
    this.preorderInput.disabled = true;
  }

  enableOption() {
    this.idInput.disabled = false;
    this.quantityInput.disabled = false;

    if (Number(this.quantityInput.value) < 1) {
      this.quantityInput.value = 1;
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const inputs = this.productForm.querySelectorAll(
      `input[name="items[${this.dataset.index}][id]"], input[name="id"]`
    );

    inputs.forEach((input) => {
      input.value = this.currentVariant.id;
      input.disabled = false;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    })
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    if (this.productForm) this.productForm.handleErrorMessage();
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  togglePreorder() {
    const preorderInput = document.querySelector(
      `[name="items[${this.dataset.index}][properties[Pre-order]]"]`
    );

    if (!preorderInput) return;

    if (this.currentVariant.preorder) {
      preorderInput
        .closest("preorder-input")
        .showMessage(this.currentVariant.preorder);
    } else {
      preorderInput.closest("preorder-input").hideMessage();
    }
  }

  announceVariantChange() {
    if (!this.currentVariant) return;
    
    const section = this.closest("section");
    if (!section) return;
    
    const variantStatus = section.querySelector(`#ProductVariantStatus-${section.dataset.section}`);
    const availabilityStatus = section.querySelector(`#ProductAvailabilityStatus-${section.dataset.section}`);
    
    if (variantStatus) {
      const variantTitle = this.currentVariant.title || this.currentVariant.options?.join(' / ') || 'Variant';
      variantStatus.textContent = `Variant changed to ${variantTitle}`;
      setTimeout(() => {
        variantStatus.textContent = '';
      }, 2000);
    }
    
    if (availabilityStatus && this.currentVariant.available !== undefined) {
      const availability = this.currentVariant.available ? 'available' : 'sold out';
      availabilityStatus.textContent = `Variant is ${availability}`;
      setTimeout(() => {
        availabilityStatus.textContent = '';
      }, 2000);
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantSelectGroup extends HTMLElement {
  constructor() {
    super();
    this.mobileTriggerButton = this.querySelector(".product-form__submit");
    this.productFormWrapper = document.querySelector(".product-form-wrapper");
    this.submitButton = document.querySelector(
      'product-form  button[type="submit"]'
    );
  }

  updateForm() {
    this.toggleAddButton();
    this.toggleShopifyPaymentButton();
  }

  toggleAddButton() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    const disable = Array.from(this.querySelectorAll("variant-radios")).every(
      (variantSelect) =>
        !(
          variantSelect.currentVariant && variantSelect.currentVariant.available
        )
    );

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      addButtonText.textContent = window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute("disabled");

      const isPreorder = Array.from(
        this.querySelectorAll("variant-radios")
      ).some(
        (variantSelect) =>
          variantSelect.currentVariant && variantSelect.currentVariant.preorder
      );

      addButtonText.textContent = isPreorder
        ? window.variantStrings.preorder
        : window.variantStrings.addToCart;
    }
  }

  toggleShopifyPaymentButton() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    const shopifyPaymentButton = productForm.querySelector(
      ".product__shopify-payment-button-wrapper"
    );
    if (!shopifyPaymentButton) return;

    const isPreorder = Array.from(this.querySelectorAll("variant-radios")).some(
      (variantSelect) =>
        variantSelect.currentVariant && variantSelect.currentVariant.preorder
    );

    if (isPreorder) {
      shopifyPaymentButton.classList.add("hidden");
    } else if (this.dataset.productType !== "Sets") {
      shopifyPaymentButton.classList.remove("hidden");
    }
  }
}

customElements.define("variant-select-group", VariantSelectGroup);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function goBack() {
  window.history.back();
}

class MultiLineToHtml extends HTMLElement {
  constructor() {
    super();

    const textWrapper = this.querySelector(".metafield-multi_line_text_field");
    
    if (textWrapper) {
      textWrapper.innerHTML = textWrapper.textContent
    }
  }
}

customElements.define("multiline-to-html", MultiLineToHtml);


class CustomScroll extends HTMLElement {
  constructor() {
    super();

    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );

    this.slider = this.querySelector(".product-slider");

    this.scrollSize = this.querySelector(
      ".product-slider__slider-item"
    ).clientWidth;

    const controlLeft = this.querySelector(".product-slider__control--left");
    
    if (controlLeft) controlLeft.addEventListener("click", this.handleLeftScroll.bind(this));

    const controlRight = this.querySelector(".product-slider__control--right");
    if (controlRight) controlRight.addEventListener("click", this.handleRightScroll.bind(this));

    this.counterCurrent = this.querySelector(".custom-scroll__counter__current");
    this.counterTotal = this.querySelector(".custom-scroll__counter__total");
    this.map = this.querySelector(".custom-scroll__map");
  }

  connectedCallback() {
    if (this.counterCurrent || this.map) {
      const handleIntersection = (entries) => {
        if (!entries[0].isIntersecting) return;

        const page = Number(entries[0].target.dataset.page);

        if (this.counterCurrent) {
          this.counterCurrent.textContent = page < 10 ? `0${page}` : page;
        } else {
          this.map
            .querySelectorAll(".custom-scroll__map__item")
            .forEach((node, i) => {
              const isCurrentPage = page === i + 1;
              if (isCurrentPage) {
                node.classList.add("custom-scroll__map__item--active");
              } else {
                node.classList.remove("custom-scroll__map__item--active");
              }
            });
        }
      }

      this.slider.querySelectorAll(".product-slider__slider-item[data-page]").forEach((sliderItem) => {
        new IntersectionObserver(handleIntersection.bind(this), {
          root: this.slider,
          rootMargin: "0px 0px 0px 0px",
          threshold: 0.51,
        }).observe(sliderItem);
      });
    }
  }

  getScrollSize() {
    return this.querySelector(".product-slider__slider-item").clientWidth;
  }

  handleLeftScroll() {
    const slider = this.querySelector(".product-slider");

    let newScroll = slider.scrollLeft - this.getScrollSize();

    if (newScroll < 0) {
      newScroll = 0;
    }

    if (newScroll !== slider.scrollLeft) {
      slider.scrollTo({
        left: newScroll,
      });
    }
  }

  handleRightScroll() {
    const slider = this.querySelector(".product-slider");

    let newScroll = slider.scrollLeft + this.getScrollSize();

    if (newScroll > slider.scrollWidth) {
      newScroll = slider.scrollWidth;
    }

    if (newScroll !== slider.scrollLeft) {
      slider.scrollLeft = newScroll;
    }
  }
}

customElements.define("custom-scroll", CustomScroll);

class ProductSlider extends HTMLElement {
  constructor() {
    super();

    this.handleVariantDisplay = this.handleVariantDisplay.bind(this);

    const sliderOverlayCTA = this.querySelector(
      ".slider-item__overlay__cta--quick-buy"
    );

    if (sliderOverlayCTA)
      sliderOverlayCTA.addEventListener(
        "click",
        this.handleVariantDisplay.bind(this)
      );

    this.addEventListener("mouseleave", this.handleVariantRemove.bind(this));

    this.submitButton = this.querySelector(
      "form[action*='/cart/add'] button[type='submit']"
    );

    this.submitButton.addEventListener("click", this.handleKlaviyoAtc.bind(this));
  }

  connectedCallback() {
    Array.from(this.querySelectorAll('input[type="radio"]')).forEach((item) =>
      item.addEventListener("change", this.handleVariantChange.bind(this))
    );

    const variantData = this.querySelector(
      '[type="application/json"]'
    )?.textContent;

    this.variantData = variantData ? JSON.parse(variantData) : [];

    Array.from(this.querySelectorAll('.card-product__variation')).forEach((item) =>
      item.addEventListener("click", this.handleColorChange.bind(this))
    );
  }

  handleKlaviyoAtc() {
    const productData = {
      // Populate with your product data
      Name: this.submitButton.getAttribute("data-product-name"),
      ProductID: this.submitButton.getAttribute("data-product-id"),
      URL: `https://finesse.us${this.submitButton.getAttribute("data-product-url")}`,
      ImageURL: `https:${this.submitButton.getAttribute("data-product-image-url")}`,
      Price: this.submitButton.getAttribute("data-product-price"),
    };

    // Trigger Klaviyo "Add to Cart" event
    _learnq.push(["track", "Added to Cart", productData]);
  }

  handleVariantChange(e) {
    const currentVariant = this.variantData.find((variant) => {
      return variant.option === e.target.value;
    });

    if (!currentVariant) return;

    const dataInput = this.querySelector('input[name="id"]');
    dataInput.value = currentVariant.id;

    const existingPreorderElement = this.querySelector(
      'input[name="properties[Pre-order]"]'
    );

    if (existingPreorderElement) {
      existingPreorderElement.parentElement.removeChild(
        existingPreorderElement
      );
    }

    const cta = this.querySelector(".slider-variant-add");
    if (currentVariant.preorderMsg) {
      const preorderElement = document.createElement("input");

      preorderElement.type = "hidden";
      preorderElement.name = "properties[Pre-order]";
      preorderElement.value = currentVariant.preorderMsg;

      this.querySelector("form").appendChild(preorderElement);
      cta.textContent = "Pre-order";
      
    } else {
      cta.textContent = "Quick Add";
    }

    if (this.submitButton.hasAttribute("disabled")) {
      this.submitButton.removeAttribute("disabled");
    }
  }

  handleColorChange(e) {
    this.classList.remove("product-card__active-color")
    this.closest(".product-card-variation-wrapper").querySelector(`product-slider[data-id="${e.target.dataset.id}"]`).classList.add("product-card__active-color");
  }

  handleVariantDisplay() {
    this.classList.add("product-slider__slider-item--quick-add");
  }

  handleVariantRemove() {
    this.classList.remove("product-slider__slider-item--quick-add");
  }
}

customElements.define("product-slider", ProductSlider);


if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form
          .querySelectorAll(".product-form__id-input")
          .forEach((item) => {
            if (item.dataset.inStock === "true") {
              item.disabled = false;
            }
          });
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.loader = this.querySelector(".loading-overlay__spinner");
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt, callback) {
        if (evt) evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (this.loader) {
          this.loader.classList.remove("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const formObj = {
          items: [],
          sections: formData.get("sections").split(","),
          sections_url: formData.get("sections_url"),
        };

        Array.from(formData.entries()).forEach(([key, value]) => {
          if (!(/items\[[0-9]+\]\[id\]/.test(key))) return;

          const index = key.replace("items[", "").replace("][id]", "");

          const item = {
            id: value,
            quantity: formData.get(`items[${index}][quantity]`),
          };

          const preorderMsg = formData.get(
            `items[${index}][properties[Pre-order]]`
          );

           const notification = formData.get(
             `items[${index}][properties['Final Sale']]`
           );

           const properties = {};

          if (preorderMsg) {
            properties["Pre-order"] = preorderMsg;
          }

          if (notification) {
            properties["Final Sale"] = notification;
          }

          if (Object.values(properties).length) {
            item.properties = properties;
          }

          formObj.items.push(item);
        });

        if (!formObj.items.length && formData.get("id")) {
          const item = {
            id: formData.get("id"),
            quantity: formData.get("quantity") || 1,
          };

          const preorderMsg = formData.get("properties[Pre-order]");

          if (preorderMsg) {
            item.properties = {
              "Pre-order": preorderMsg,
            };
          }

          formObj.items.push(item);
        }


        config.body = JSON.stringify(formObj);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            
            this.cart.renderContents(response);

            const sourceCollection = this.querySelector('.atc-btn')?.dataset.collection;

            if (sourceCollection) {
              gtag('event', 'custom_add_to_cart', {
                event_category: sourceCollection,
                event_label: `${sourceCollection}_add_to_cart`,
                url: window.location.href.split('?')[0]
              });
            }

            if (callback) {
              callback(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            this.submitButton.classList.add("loaded");
            setTimeout(() => {
              this.submitButton.classList.remove("loaded");
            }, 500);

            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");

            if (this.loader) {
              this.loader.classList.add("hidden");
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {  
          if (/^All .+are in your cart.$/.test(errorMessage)) {
            errorMessage = message
              .replace("All", "You can only add up to")
              .replace("are in your cart", "to your cart");
          }
  
          //   if (/^You can't add more .+to the cart.$/.test(errorMessage)) {
          //     errorMessage = errorMessage
          //       .replace(
          //         "You can't add more",
          //         `You can only add up to ${quantityElement.max}`
          //       )
          //       .replace("to the cart", "to your cart");
          //   }
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class ImgLazy extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector("img");
    this.container = this.closest(".product-slider") || this.closest(".collection-outline");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.image.setAttribute("loading", "eager");
    };

    const observer = new IntersectionObserver(handleIntersection.bind(this), {
      root: this.container || null,
      rootMargin: "0px 720px 720px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("img-lazy", ImgLazy);

class DropLoadMore extends HTMLElement {
  constructor() {
    super();
    this.container = this.closest(".product-slider");
    this.productSlider = this.closest("ul");
    this.nextPageUrl = null;
    this.isLoading = false;
  }

  connectedCallback() {
    this.listenForLoadMore();
  }

  listenForLoadMore() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting || this.isLoading) return;
      
      const nextPageLink = this.querySelector("a");
      if (nextPageLink) {
        this.nextPageUrl = nextPageLink.href;
        this.loadMore();
      }
    };

    this.observer = new IntersectionObserver(
      handleIntersection.bind(this),
      {
        root: this.container,
        rootMargin: "0px 720px 720px 0px",
      }
    );

    this.observer.observe(this);
  }

  getSectionId() {
    return this.dataset.sectionId;
  }

  getCollectionUrl() {
    return this.dataset.collectionUrl;
  }

  async loadMore() {
    if (!this.nextPageUrl || this.isLoading) return;

    this.isLoading = true;
    this.observer.unobserve(this);

    // Show skeleton loader
    this.showSkeletonLoader();

    try {
      // Fetch the next page with section_id parameter
      const response = await fetch(`${this.nextPageUrl}&view=drop`);
      const responseText = await response.text();
      
      // Hide skeleton loader
      this.hideSkeletonLoader();
      
      // Parse the response to find the collection drop section
      const newPage = new DOMParser().parseFromString(responseText, "text/html");
      const collectionDropElement = newPage.querySelector(".collection-drop");
      
      if (collectionDropElement) {
        // Find all product slider items in the new page
        const newProductCards = collectionDropElement.querySelectorAll('.product-slider__slider-item:not(:last-child)');
        
        // Insert the new product cards before the load-more element
        newProductCards.forEach(card => {
          const clonedCard = card.cloneNode(true);
          this.productSlider.insertBefore(clonedCard, this.closest("li"));
        });

        // Check if there's a next page by looking for the drop-load-more element
        const newDropLoadMore = collectionDropElement.querySelector("drop-load-more");
        if (newDropLoadMore) {
          const newNextPageLink = newDropLoadMore.querySelector("a");
          if (newNextPageLink) {
            this.innerHTML = newDropLoadMore.innerHTML;
            this.nextPageUrl = newNextPageLink.href;
            // Re-observe for next load
            this.observer.observe(this);
          } else {
            // No more pages, remove the load more element
            this.closest("li").remove();
          }
        } else {
          // No more load-more element, remove the current one
          this.closest("li").remove();
        }
      } else {
        // No collection drop found, remove the load more element
        this.closest("li").remove();
      }
    } catch (error) {
      console.error("Error loading more products:", error);
      // Hide skeleton loader on error
      this.hideSkeletonLoader();
      // Re-observe in case of error to allow retry
      this.observer.observe(this);
    } finally {
      this.isLoading = false;
    }
  }

  showSkeletonLoader() {
    const listItem = this.closest("li");
    const skeletonLoader = this.querySelector(".drop-skeleton-loader");
    if (listItem) {
      listItem.classList.add("product-slider__slider-item");
    }
    if (skeletonLoader) {
      skeletonLoader.classList.remove("hidden");
    }
  }

  hideSkeletonLoader() {
    const listItem = this.closest("li");
    const skeletonLoader = this.querySelector(".drop-skeleton-loader");
    if (listItem) {
      listItem.classList.remove("product-slider__slider-item");
    }
    if (skeletonLoader) {
      skeletonLoader.classList.add("hidden");
    }
  }
}

customElements.define("drop-load-more", DropLoadMore);

class SignUpButton extends HTMLElement {
  constructor() {
    super();
    const signUpButton = this.querySelector(".coming-soon-button");
    if (signUpButton) {
      signUpButton.addEventListener("click", this.handleSignUp.bind(this));
    }
  }

  handleSignUp() {
    const attentiveCreativeIdSmall = this.getAttribute('attentive-creative-id-small');
    const attentiveCreativeIdLarge = this.getAttribute('attentive-creative-id-large');
    const attentiveCreativeId = window.innerWidth < 750 ? attentiveCreativeIdSmall : attentiveCreativeIdLarge;
    if (attentiveCreativeId == 0) {
      return
    }

    const loader = this.querySelector(".loading-overlay");
    if (loader) {
      loader.classList.remove("hidden");

      // Set a timer to make sure the loader will be hid when attentive UI fails to load.
      let timeout = setTimeout(() => {
        if (!loader.classList.contains("hidden")) {
          loader.classList.add("hidden");
        }
      }, 5000);

      var observer = new MutationObserver(function(mutations) {
        for(let mutation of mutations) {
          if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
            observer.disconnect()
            clearTimeout(timeout);
            loader.classList.add("hidden");
            break;
          }
        }
      });
  
      const targetNode = document.getElementById('MainContent');
      observer.observe(targetNode, {
        attributes: true
      });
    }

    window.__attentive.trigger(null, null, null, attentiveCreativeId)
  }
}

customElements.define("sign-up-button", SignUpButton);
